import { IRacefacerTrack } from "../interfaces/racefacer";

export { ROUTES } from "./routes";

export const AlgoliaIndexes = {
  SmsLogs: "sms_logs",
  Drivers: "drivers",
};

export const TrackConfigurations: IRacefacerTrack[] = [
    {
        "id": 9,
        "name": "Mini Track",
        "is_calibrated": true,
        "turns": 5,
        "length": 34,
        "is_active": 1,
        "uuid": "1c99b01d-f131-4f02-b8b3-5d8d1585e52e",
        "sub_track_id": 2,
        "sub_track_name": "Mini Track",
        "number_of_sectors": 0
    },
    {
        "id": 14,
        "name": "VR",
        "is_calibrated": false,
        "turns": 2,
        "length": 1000,
        "is_active": 1,
        "uuid": "f36b4787-9dac-4ae8-aceb-26e6d518b82f",
        "sub_track_id": 3,
        "sub_track_name": "VR",
        "number_of_sectors": 0
    },
    {
        "id": 15,
        "name": "Intermediate Track",
        "is_calibrated": false,
        "turns": 10,
        "length": 500,
        "is_active": 1,
        "uuid": "2321c219-4527-414f-984e-fcc46a0006d3",
        "sub_track_id": 4,
        "sub_track_name": "Intermediate Track",
        "number_of_sectors": 0
    },
    {
        "id": 16,
        "name": "Junior Track",
        "is_calibrated": false,
        "turns": 10,
        "length": 500,
        "is_active": 1,
        "uuid": "9c3dc31c-3fa5-40b2-b03e-5c607473714d",
        "sub_track_id": 5,
        "sub_track_name": "Junior Track",
        "number_of_sectors": 0
    },
    {
        "id": 37,
        "name": "Monza 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 450,
        "is_active": 0,
        "uuid": "7ce31d9c-9a7e-4ff3-a3aa-bb7098a74ee9",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 38,
        "name": "Monza 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 450,
        "is_active": 0,
        "uuid": "45fc3c62-72f9-4ce4-83dc-c0356dfcbd1c",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 39,
        "name": "Silverstone 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 450,
        "is_active": 0,
        "uuid": "6d83def4-494d-4702-bd70-aa7584735897",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 40,
        "name": "Silverstone 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 450,
        "is_active": 0,
        "uuid": "065816cf-a257-4737-a201-75108d262df0",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 41,
        "name": "Junior Track, Clockwise",
        "is_calibrated": false,
        "turns": 10,
        "length": 500,
        "is_active": 0,
        "uuid": "4f588e03-e058-4816-90c0-7da1be1c207d",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 1
    },
    {
        "id": 42,
        "name": "Albert Park 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "5396004e-9c24-41ea-a2fe-04438faa19f9",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 43,
        "name": "Albert Park 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "1690d8ee-05cd-4d22-95fb-61adb1ae10d1",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 44,
        "name": "Imola 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "570f12e0-160d-4f89-86de-78addeafa4e6",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 45,
        "name": "Imola 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "f03859aa-5d56-499c-9503-c33a439afce0",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 46,
        "name": "Imola 2, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "3df218a2-29ea-4097-9203-a5773a5c1d74",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 47,
        "name": "Imola 2, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "5c8ec3ba-c2f2-444b-8a25-2d5577331acc",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 48,
        "name": "Silverstone 2, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "a35e67fb-9e87-4e9b-a066-d928ee3b6652",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 49,
        "name": "Silverstone 2, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "0e706e74-85c3-4a60-9180-6b7bef1c1015",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 50,
        "name": "Albert Park 2, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "66d4e0b3-6189-4c42-bc76-6e749c1a133d",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 51,
        "name": "Albert Park 2, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "639714c2-41f9-4b59-b489-8f68cdc85beb",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 52,
        "name": "Albert Park 3, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 1,
        "uuid": "03938512-4de1-4fe7-a97f-9d76bee9be75",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 53,
        "name": "Albert Park 3, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "37be12db-4304-4280-bfc0-1d90f02c2fb1",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 54,
        "name": "Spa 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 1,
        "uuid": "f399fb87-8bec-4573-838c-dabbc41dc583",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 55,
        "name": "Spa 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "4c26b196-3bbb-4d38-922f-8409588b7c33",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 56,
        "name": "Spa 2, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "323edd22-3449-47dd-be77-897cf4685a31",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 57,
        "name": "Spa 2, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "bf92f739-336a-48a2-a813-f20dc84f556a",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 58,
        "name": "Marina Bay 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 1,
        "uuid": "371b9c1b-01df-4fb4-bcc3-4b9470e0f412",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 59,
        "name": "Marina Bay 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "fa593bf2-aaf4-4313-85a1-3a2201d2d66a",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 60,
        "name": "Marina Bay 2, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "e413c546-6087-4dcb-abf8-b42922d359cf",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 61,
        "name": "Marina Bay 2, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "4e3062f2-e29b-47b8-999c-f382817d07a8",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },

    {
        "id": 62,
        "name": "Bahrain 1, Clockwise ",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "8b99fbd7-b443-4a27-a999-f320bda91fdd",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 63,
        "name": "Bahrain 1, Anti-Clockwise ",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "494959ba-37b1-4c07-aa53-4565e6337f3b",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 64,
        "name": "Hungaroring 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "aedf6030-0806-411b-ab9b-1fa29a95bb0a",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 65,
        "name": "Hungaroring 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "053ea0f1-099f-4be0-8b12-a53a5c91beed",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 66,
        "name": "Suzuka 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "baee4133-1653-48e9-81e8-7d8f4c510c07",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 67,
        "name": "Suzuka 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "9b31cb70-8f37-4b88-9c32-994821dfea7b",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 68,
        "name": "Shangai 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "ebf98237-518c-49cc-ae3a-e45a37d37df0",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 69,
        "name": "Shangai 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "1b047ea1-531a-45ab-a821-6b188c43c384",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 70,
        "name": "Interlagos 1, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "dc931cd5-8101-4a28-bb86-842021d3aae5",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 71,
        "name": "Interlagos 1, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "e6543def-3716-4c4a-9833-1e39164edcf4",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 72,
        "name": "Hungaroring 2, Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "416d02c2-518c-4cad-a6fd-dfe203e34419",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    },
    {
        "id": 73,
        "name": "Hungaroring 2, Anti-Clockwise",
        "is_calibrated": false,
        "turns": 15,
        "length": 350,
        "is_active": 0,
        "uuid": "18cacba2-ec73-43c3-8f72-2c59d70fb460",
        "sub_track_id": 1,
        "sub_track_name": "Adult Track",
        "number_of_sectors": 3
    }
]

export const DefaultTrackConfig = "6d83def4-494d-4702-bd70-aa7584735897"